import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.12.4_eslint@8.57.0_less@4.2.0_rollup@4.20.0_typescript@5.5.4_vite@5.4.0/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}